import requests from "./httpService";

const StoreService = {
     getAllStore: async () =>{
        return requests.get("/store");
     },
     getStoreById: async (id, body) =>{
        return requests.get(`/store/${id}`, body);
     },
     UpdateStoreById: async (id, body) =>{
        return requests.put(`/store/${id}`, body);
     },
     addStore: async (body) =>{
        return requests.post("/store/addstore", body);
     },
     deleteStoreById: async (id) =>{
        return requests.delete(`/store/${id}`);
     }
}

export default StoreService;